import { useEffect } from "react";
import { useLocation } from "react-router";

import { Box, Stack, useMediaQuery } from "@mui/material";

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default function WorkspaceContainer({ navMenu, children }) {
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("md"), { noSsr: true });

  return (
    <>
      <ScrollToTop />
      <Stack
        direction="row"
        className="workspace-stack-container"
        sx={{ width: isSmall ? "calc(100% - 8px)" : "calc(100% - 16px)" }} // symmetric 16px gutters on desktop
      >
        <Box className="navigation leftNav" sx={{ zIndex: isSmall ? 1201 : 1000 }}>
          {navMenu}
        </Box>

        <Box
          className="workspace-body-container"
          sx={{
            // Let flexbox size this next to the docked nav drawer (90px collapsed / 325px open).
            // An explicit width here ignored the collapsed rail + left margin and overflowed the viewport,
            // giving the page its own horizontal scrollbar on top of the DataGrid's.
            flex: 1,
            minWidth: 0,
            p: 0,
            // overflow: "clip",
            ml: isSmall ? 1 : 2,
            mr: 0,
          }}
        >
          {children}
        </Box>
      </Stack>
    </>
  );
}
